<template>
  <div class="task-records-wrapper">
    <div class="card-header-divider">
      <p>История записей</p>
    </div>

    <div class="records_control_wrapper">
      <div class="records_header">
        Записи за <span>{{ startDate === maxDate ? 'Сегодня' : '' }}</span>
      </div>

      <input
          type="date"
          :max="maxDate"
          :value="startDate"
          @input="$emit('update:startDate', $event.target.value)"
      >
    </div>

    <div v-if="isLoaded">
      <table v-if="currentData && currentData.length" class="table-sm w-full">
        <thead>
        <tr>
          <th>Время задачи</th>
          <th>Задача</th>
          <th>Квадрат</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="record in currentData" :key="record.id">
          <td>{{ record.interval }}</td>
          <td>{{ record.title }}</td>
          <td>
            <div class="square-dot" :style="{ backgroundColor: record.color }"></div>
          </td>
        </tr>
        </tbody>
      </table>

      <ul v-if="currentData && currentData.length" class="records_list">
        <li v-for="record in currentData" :key="record.id">
          <div class="record_wrapper">
            <p>Время задачи: <span>{{ record.interval }}</span></p>
            <p>Задача: <span>{{ record.title }}</span></p>
            <div class="square-record-wrapper">
              Квадрат:
              <div class="square-dot" :style="{ backgroundColor: record.color }"></div>
            </div>
          </div>
        </li>
      </ul>

      <div v-else class="no_results">
        <p>Нет записей</p>
      </div>
    </div>

    <div class="records_loader" v-else>
      <mini-preloader />
    </div>
  </div>
</template>

<script>
import { computed, onBeforeMount, ref, watch } from 'vue'
import { useStore } from 'vuex'
import MiniPreloader from "@/components/Technical/MiniPreloader.vue";
import {onBeforeUnmount} from "@vue/runtime-core";

export default {
  name: "TrackerRecords",
  components: { MiniPreloader },
  props: {
    startDate: {
      type: String,
      required: true
    }
  },
  emits: ['update:startDate'],
  setup(props) {
    const store = useStore();
    const currentRecords = computed(() => store.state.tracker.userTasks);
    const isLoaded = ref(false);
    const currentData = ref([]);

    const today = new Date()
    const currentDate = today.getDate();
    const currentMonth = today.getMonth() + 1;
    const maxDate = today.getFullYear() + '-' + (currentMonth < 10 ? '0' + currentMonth : currentMonth) + '-' + (currentDate < 10 ? '0' + currentDate : currentDate);

    const colorMap = {
      'Красный': '#9c0130',
      'Жёлтый': '#ff9e02',
      'Желтый': '#ff9e02',
      'Синий': '#100f76',
      'Зелёный': '#3d9123',
      'Зеленый': '#3d9123',
    }

    const getTaskTitle = (task) => {
      return task?.task?.name || task?.name || task?.title || 'Без названия';
    }

    const getTaskColor = (task) => {
      if (!task?.color?.name) {
        return '#B8BEC9';
      }

      return colorMap[task.color.name] || '#B8BEC9';
    }

    const loadData = () => {
      isLoaded.value = false;

      store.dispatch('tracker/getAllUserTasks', {
        start_date: props.startDate,
      }).then(() => {
        isLoaded.value = true;
      })
    }

    watch(() => props.startDate, () => {
      loadData();
    });

    watch(() => currentRecords.value, (records) => {
      isLoaded.value = false;
      currentData.value = (records || [])
          .filter(el => el.already_happened && el.mode === 'test')
          .map(el => ({
            id: String(el.id),
            title: getTaskTitle(el),
            interval: el.interval,
            color: getTaskColor(el),
          }));
      isLoaded.value = true;
    }, { immediate: true });

    return {
      maxDate,
      isLoaded,
      currentData
    }
  }
}
</script>

<style scoped lang="scss">
.records_control_wrapper {
  margin: 25px 0;
  display: flex;
  column-gap: 15px;
}

.no_results {
  text-align: center;
  padding: 50px 10px;
}

.records_loader {
  text-align: center;
  padding: 50px 0;
}

.records_list {
  display: none;
  padding: 10px;
  flex-direction: column;
  row-gap: 15px;
}

.records_list li {
  padding: 10px;
  background-color: #ececec;
  border-radius: 16px;
}

.record_wrapper {
  display: flex;
  flex-direction: column;
  row-gap: 5px;
}

@media (max-width: 910px) {
  .table-sm {
    display: none;
  }

  .records_list {
    display: flex;
  }
}

.square-dot {
  width: 18px;
  height: 18px;
  border-radius: 50%;
}

.square-record-wrapper {
  display: flex;
  gap: 6px;
  align-items: center;
}

.task-records-wrapper {
  margin: 35px 0;
}
</style>